module.exports = __webpack_public_path__ + "img/aliyunecs.d971267d.svg";